// extracted by mini-css-extract-plugin
export default {"root":"Slider2_root__QcY+n","label":"Slider2_label__09qZp","labelSpacing":"Slider2_labelSpacing__OgPiK","tp":"Slider2_tp__De0c1","main":"Slider2_main__YkbnV"};